import React from "react";

import { InformationIcon, UserIcon } from "../../../../../components/Icons";

import DialogStyles from "../../../../../styles/components/DialogStyles";
import { stylesBoxsModalDetalhes } from "../../../../../styles/pages/GestaoFaltas/GestaoFaltas";
import { IActivityManagementWorkflow } from "../../../../../context/interfaces/IWorkflowContext";

const { StyledModalTitle } = DialogStyles;

interface IModalProps {
    workflow: IActivityManagementWorkflow | null;
    modalTitle: string;
}

const ActivitiesManagementModalHeader: React.FC<IModalProps> = ({
    workflow,
    modalTitle,
}) => {
    return (
        <>
            <StyledModalTitle className="mb-3">
                {modalTitle || "Gestão de Atividades"}
            </StyledModalTitle>
            <div style={stylesBoxsModalDetalhes.box3}>
                <div style={stylesBoxsModalDetalhes.box4}>
                    <div>
                        <b>
                            <UserIcon
                                style={{ fill: "#8A0538", marginRight: 5 }}
                            />
                            {workflow?.docente.nome}
                        </b>
                    </div>
                    <div>
                        <b>
                            <InformationIcon
                                style={{ fill: "#8A0538", marginRight: 5 }}
                            />
                            {`Matricula: ${workflow?.docente.matriculaAdp}`}
                        </b>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ActivitiesManagementModalHeader;
